
import { SectionTitle } from "@/components/SectionTitle";
import { DoctorCard } from "@/components/DoctorCard";

export const TeamSection = () => {
  return (
    <section className="py-16 md:py-24 bg-dental-offwhite">
      <div className="container-custom">
        <SectionTitle 
          subtitle="Our Experts" 
          title="Meet Our Dental Specialists" 
          description="Our team of experienced dental professionals is committed to providing you with the highest quality care in a comfortable and welcoming environment." 
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <DoctorCard 
            name="Dr. Hemant Asrani" 
            role="MDS - Endodontist" 
            image="/lovable-uploads/efdb41d1-0ab8-4227-902b-10b6a3b129af.png" 
            description="Dr. Hemant Asrani is a highly skilled dental surgeon specializing as an endodontist, renowned for his expertise in complex procedures and dedication to quality patient care in Nagpur." 
            socials={{
              facebook: "https://facebook.com",
              twitter: "https://twitter.com",
              instagram: "https://instagram.com",
              linkedin: "https://linkedin.com"
            }} 
          />
          
          <DoctorCard 
            name="Dr. Karan Asrani" 
            role="MDS - Periodontist" 
            image="/lovable-uploads/499739a7-d200-4ee3-8350-050c6190d986.png" 
            description="Dr. Karan Asrani is a skilled periodontist specializing in implantology and full mouth rehabilitation. He offers comprehensive dental care using advanced techniques to ensure optimal oral health." 
            socials={{
              facebook: "https://facebook.com",
              twitter: "https://twitter.com",
              instagram: "https://instagram.com",
              linkedin: "https://linkedin.com"
            }} 
          />
          
          <DoctorCard 
            name="Dr. Nidhi Asrani" 
            role="BDS, MA" 
            image="/lovable-uploads/1be6e61b-063b-4ca2-8165-26aa828b7a14.png" 
            description="Dr. Nidhi Asrani is a skilled dentist, recognized for her expertise in delivering comprehensive dental care. She prioritizes creating a comfortable and supportive environment, ensuring patients receive personalized and effective treatment." 
            socials={{
              facebook: "https://facebook.com",
              twitter: "https://twitter.com",
              instagram: "https://instagram.com",
              linkedin: "https://linkedin.com"
            }} 
          />
        </div>
      </div>
    </section>
  );
};
